import { NumberFormatPipe } from './modules/pipe/number-format.pipe';
import { switchMap } from 'rxjs/operators';
import { PublicReportService } from './modules/services/public-report.service';
import { Component, OnInit, AfterViewInit, ViewChild, OnChanges,HostListener } from '@angular/core';
import * as $ from 'jquery';
import { ChartDataSets, ChartLegendItem, ChartOptions, ChartType, Chart } from 'chart.js';
import * as _ from 'lodash';
import * as _moment from 'moment';
const moment = _moment;
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable } from 'rxjs';
// import { Console } from 'console';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { I18nService } from './modules/i18n/i18n.service';
import { MainDashboardComponent } from './components/main-dashboard/main-dashboard.component';
import { RegistrationDashboardComponent } from './components/registration-dashboard/registration-dashboard.component';
import { VaccinationDashboardComponent } from './components/vaccination-dashboard/vaccination-dashboard.component';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import{NewMainDashboardComponent} from './components/new-main-dashboard/new-main-dashboard.component'
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [DatePipe, NumberFormatPipe]
})
export class AppComponent implements OnInit, AfterViewInit {

  @ViewChild(MainDashboardComponent) mainDashboard: MainDashboardComponent;
  @ViewChild(RegistrationDashboardComponent) regDashboardRprt: RegistrationDashboardComponent;
  @ViewChild(VaccinationDashboardComponent) vaccDashboardRprt: VaccinationDashboardComponent;
  @ViewChild(NewMainDashboardComponent) newmainDashboard:NewMainDashboardComponent;

  selectedTabLabel = '';
  headerTextLbl = 'State';
  breadCrumbArr = [];
  title = 'cowindashboard';
  reportData;
  stateWiseBeneficiaries;
  dailySessionsSummaryByState;
  dailySessionsData;
  vaccinationDataAtDiffTimes;
  vaccinePlannedGivenData;
  vaccinatedBeneficiaryByGender;
  vaccinatedBeneficiaryByMaterial;
  realTimeChart;
  realTimeChart30Days
  lineChartData;
  vaccinationByDay;
  updateInterval = 300;
  updateCount = 0;
  numberOfElements = 200;
  vaccinationDoneByDay;
  stateArr;
  states;
  statename;
  heading;
  myChartGender;
  myChartBenficiariesVsVaccinated;
  myChartTotalVaccinatedByMaterial;
  myChartTodayTotalVaccination;
  myChartForSessionData;
  districtArr;
  districtList;
  districtListfromstate;
  district_id;
  state_id;
  districtname;
  totally_vaccinated;
  todaysdate;
  statelogo;
  cowinlogo;
  isnational = true;
  mobile = false;
  onload = true;
  districtId;
  datechange;
  totalDoseOne;
  totalDoseTwo;
  myChartDose1VsDose2;
  totaldoses;
  tableheader;
  isStates;
  site_logo;
  type = "India";
  currLang = 'en';
  constructor(
    private publicReportService: PublicReportService,
    public deviceService: DeviceDetectorService,
    public datepipe: DatePipe,
    public numberFormatPipe: NumberFormatPipe,
    private activatedRoute: ActivatedRoute,
    private i18nService: I18nService,
    private translate: TranslateService,
    private titleService: Title,
  ) {
      this.activatedRoute.queryParams.subscribe( (params: any) => {
        if(params && params['lang']) {
          this.i18nService.language = params['lang'];
        }
      });
  }

  ngOnInit(): void {
    this.currLang = this.translate.currentLang;
    this.translate.onLangChange.subscribe( (r: any) => {
      console.log('translate.onLangChange', r);
      this.currLang = this.translate.currentLang;
      this.titleService.setTitle(this.translate.instant('TITLE'));
    });
    this.todaysdate = new Date();
    this.todaysdate = this.datepipe.transform(this.todaysdate, 'yyyy-MM-dd')
    // document.getElementById("dateId").setAttribute("max", this.todaysdate);
    console.log("this.todaysdate", this.todaysdate)
    if (window.screen.width === 360 || window.screen.width === 768) { // 768px portrait
      this.mobile = true;
    }
    this.states = [
      {
        "state_id": 1,
        "state_code": "AN",
        "state_name": "Andaman and Nicobar Islands"
      },
      {
        "state_id": 2,
        "state_code": "AP",
        "state_name": "Andhra Pradesh"
      },
      {
        "state_id": 3,
        "state_code": "AR",
        "state_name": "Arunachal Pradesh",

      },
      {
        "state_id": 4,
        "state_code": "AS",
        "state_name": "Assam"
      },
      {
        "state_id": 5,
        "state_code": "BR",
        "state_name": "Bihar"
      },
      {
        "state_id": 6,
        "state_code": "CH",
        "state_name": "Chandigarh"
      },
      {
        "state_id": 7,
        "state_code": "CG",
        "state_name": "Chhattisgarh"
      },
      {
        "state_id": 8,
        "state_code": "DH",
        "state_name": "Dadra and Nagar Haveli"
      },
      {
        "state_id": 37,
        "state_code": "DD",
        "state_name": "Daman and Diu"
      },
      {
        "state_id": 9,
        "state_code": "DL",
        "state_name": "Delhi"
      },
      {
        "state_id": 10,
        "state_code": "GA",
        "state_name": "Goa"
      },
      {
        "state_id": 11,
        "state_code": "GJ",
        "state_name": "Gujarat"
      },
      {
        "state_id": 12,
        "state_code": "HR",
        "state_name": "Haryana"
      },
      {
        "state_id": 13,
        "state_code": "HP",
        "state_name": "Himachal Pradesh"
      },
      {
        "state_id": 14,
        "state_code": "JK",
        "state_name": "Jammu and Kashmir"
      },
      {
        "state_id": 15,
        "state_code": "JH",
        "state_name": "Jharkhand"
      },
      {
        "state_id": 16,
        "state_code": "KA",
        "state_name": "Karnataka"
      },
      {
        "state_id": 17,
        "state_code": "KL",
        "state_name": "Kerala"
      },
      {
        "state_id": 18,
        "state_code": "LA",
        "state_name": "Ladakh"
      },
      {
        "state_id": 19,
        "state_code": "LD",
        "state_name": "Lakshadweep"
      },
      {
        "state_id": 20,
        "state_code": "MP",
        "state_name": "Madhya Pradesh"
      },
      {
        "state_id": 21,
        "state_code": "MH",
        "state_name": "Maharashtra"
      },
      {
        "state_id": 22,
        "state_code": "MN",
        "state_name": "Manipur"
      },
      {
        "state_id": 23,
        "state_code": "ML",
        "state_name": "Meghalaya"
      },
      {
        "state_id": 24,
        "state_code": "MZ",
        "state_name": "Mizoram"
      },
      {
        "state_id": 25,
        "state_code": "NL",
        "state_name": "Nagaland"
      },
      {
        "state_id": 26,
        "state_code": "OD",
        "state_name": "Odisha"
      },
      {
        "state_id": 27,
        "state_code": "PY",
        "state_name": "Puducherry"
      },
      {
        "state_id": 28,
        "state_code": "PB",
        "state_name": "Punjab"
      },
      {
        "state_id": 29,
        "state_code": "RJ",
        "state_name": "Rajasthan"
      },
      {
        "state_id": 30,
        "state_code": "SK",
        "state_name": "Sikkim"
      },
      {
        "state_id": 31,
        "state_code": "TN",
        "state_name": "Tamil Nadu"
      },
      {
        "state_id": 32,
        "state_code": "TS",
        "state_name": "Telangana"
      },
      {
        "state_id": 33,
        "state_code": "TR",
        "state_name": "Tripura"
      },
      {
        "state_id": 34,
        "state_code": "UP",
        "state_name": "Uttar Pradesh"
      },
      {
        "state_id": 35,
        "state_code": "UK",
        "state_name": "Uttarakhand"
      },
      {
        "state_id": 36,
        "state_code": "WB",
        "state_name": "West Bengal"
      }

    ]
    // this.getReportData();
    // this.getReportDataforDate()
    // this.getNewDashboardData();
    // this.initializeRealTimeChart();
    // this.updateData();
    // console.log("check", this.publicReportService.filterParams.heading);
    this.heading = this.publicReportService.filterParams.heading ? this.publicReportService.filterParams.heading : "National";
    this.site_logo = this.publicReportService.filterParams.site_logo ? this.publicReportService.filterParams.site_logo : "AN";

    this.publicReportService.getSessionStatus().subscribe(val => {
 console.log("checking22", val);
      if (val != undefined) {

        this.state_id = val;
        if(this.state_id){
        this.stateArr = this.states.find(e => e.state_id == val);
        this.heading = this.stateArr.state_name;
        this.site_logo = this.stateArr.state_code;
        }
        //console.log("this.stateArr", this.stateArr);
        // if(val==''){
        //   this.heading = "National";
        // }
      }
    })



    this.publicReportService.getNationalStatus().subscribe(val => {
      this.heading = "National";
      if (val != undefined) {
        //console.log("checking", val);

        this.heading = "National";
        this.site_logo = "AN";

      }
    })

    this.publicReportService.getDistrictID().subscribe(val => {
      if (val != undefined) {
        //console.log("checking", val);

        this.district_id = val;

      }
    })

    // this.publicReportService.getType().subscribe(val => {

    //   console.log("type", this.state_id)
    //   if (val != undefined) {

    //     this.type = val;
    //     this.breadCrumbArr = [];
    //     if(this.type == 'State'){
    //     if(this.state_id){

    //       this.stateArr = this.states.find(e => e.state_id == this.state_id);
    //       this.heading = this.stateArr.state_name;
    //       this.site_logo = this.stateArr.state_code;
    //     }

    //     }else if(this.type == 'District'){
    //       this.stateArr = this.states.find(e => e.state_id == this.state_id);
    //       this.site_logo = this.stateArr.state_code;
    //       this.heading = this.districtname;
    //     }else if(this.type == 'India'){
    //       this.heading = 'National';
    //       this.site_logo = 'AN';
    //     }else{
    //       this.heading = 'National';
    //       this.site_logo = 'AN';
    //       console.log('test');
    //     }

    //   }
    // })

    this.publicReportService.getStatename().subscribe(val => {
      if (val != undefined) {
        //console.log("checking", val);

        this.statename = val;

      }
    })

    this.publicReportService.getDistrictname().subscribe(val => {
      console.log("checking3", val);
      if (val && val != undefined) {
        console.log("checking123", val);
        this.districtname = val;
        this.heading = val;
        console.log("heading",  this.heading)
      }
    })

    // this.publicReportService.getTabname().subscribe(val => {

    //   if (val != undefined) {
    //     //console.log("checkingddd", val);
    //     if (val === 'Registration' || val === 'Vaccination' ) {
    //       this.heading = "National";
    //       this.site_logo = "AN";
    //     }else if(val === 'Dashboard'){
    //       //console.log('state'+this.state_id+' '+this.district_id+' '+this.districtname);
    //       if(this.state_id){
    //         //console.log("testing22", this.state_id);
    //         this.stateArr = this.states.find(e => e.state_id ==  this.state_id);
    //         this.heading = this.stateArr.state_name;
    //         this.site_logo = this.stateArr.state_code;
    //       }
    //       if(this.districtname){
    //         //console.log("district", val);
    //         this.stateArr = this.states.find(e => e.state_id ==  this.state_id);
    //         this.heading = this.districtname
    //         this.site_logo = this.stateArr.state_code;
    //       }
    //       //console.log("testing", val);

    //     }


    //   }
    // })



  }

  ngAfterViewInit() {

    let activeTabLbl = 'Dashboard';
    this.publicReportService.tabname.next("Dashboard");
    this.loadReportByTab(activeTabLbl)
    //this.loadReportByTab(activeTabLbl)
  }
  // ngOnChanges() {

  //   this.heading = this.publicReportService.filterParams.heading ? this.publicReportService.filterParams.heading : "National";
  //   this.site_logo = this.publicReportService.filterParams.site_logo ? this.publicReportService.filterParams.site_logo : "AN";
  // }



  topBlockReport;
  lineChartDataNew = [];
  lastSevenDaysReg = [];
  getBeneficiariesGroupBy = [];
  last7DaysVaccination = [];
  lastSevenDaysAppointment = [];

  lastSevenDayVaccChart;
  lastSevenDayChart;
  genderVaccPieChart;
  materialVaccPieChart;
  lastSevenDayAppointmentChart;


  // nextLevel(type, state_id='', district_id='') {
  //   this.headerTextLbl = type;
  //   this.state_id = state_id;
  //   this.district_id = district_id;
  //   console.log(type);
  //   if(this.headerTextLbl == 'Center') {
  //     this.isnational = false;
  //     this.onload = false;
  //     return;
  //   }else if(this.headerTextLbl === 'India') {
  //     this.heading = 'National';
  //     this.isnational = true;
  //     this.onload = true;
  //     this.breadCrumbArr = [];
  //     this.headerTextLbl = 'State';
  //     this.getNewDashboardData('','');
  // }else if(this.headerTextLbl === 'State') {
  //     this.breadCrumbArr = [];
  //     this.isnational = false;
  //     this.onload = false;
  //     this.stateArr = this.states.find(e => e.state_id == this.state_id);
  //     this.statename = this.stateArr.state_name;
  //     this.heading = this.statename;
  //     this.statelogo = this.stateArr.state_code;
  //     this.breadCrumbArr.push({
  //       type: 'India',
  //       id: '',
  //       name: 'India'
  //     });
  //     this.breadCrumbArr.push({
  //         type: 'State',
  //         id: this.state_id,
  //         state_id: this.state_id,
  //         state_name: this.statename,
  //         name: this.statename
  //     });
  //     // this.isStatelogin = true;
  //     this.headerTextLbl = 'District';
  //     this.getNewDashboardData(this.state_id,'');
  //   } else if(this.headerTextLbl === 'District') {
  //     this.isnational = false;
  //     this.onload = false;
  //     this.state_id = 2;
  //     this.stateArr = this.states.find(e => e.state_id == this.state_id);
  //     console.log(this.stateArr);
  //     this.statename = this.stateArr.state_name;
  //     this.statelogo = this.stateArr.state_code;
  //     if(this.breadCrumbArr.length == 0) {
  //       this.breadCrumbArr = [];
  //       this.breadCrumbArr.push({
  //         type: 'State',
  //         id: this.state_id,
  //         state_name: this.statename,
  //         state_id: this.state_id,
  //         name: this.statename
  //       });
  //     }
  //     this.districtArr = this.getBeneficiariesGroupBy.find(e => e.district_id == this.district_id);
  //     this.districtname = this.districtArr.district_name;
  //     this.heading = this.districtname;
  //     this.breadCrumbArr.push({
  //       type: 'District',
  //       id: this.district_id,
  //       district_id: this.district_id,
  //       district_name: this.districtname,
  //       name: this.districtname
  //     });
  //     this.headerTextLbl = 'Center';
  //     this.getNewDashboardData(this.state_id, this.district_id);
  //   }
  // }

  // getNewDashboardData(state_id="",district_id="") {
  //   this.state_id = state_id;
  //  this.district_id = district_id;
  //  this.state_id = state_id;
  //   this.district_id = district_id;

  //   this.publicReportService.getPublicReports(state_id,district_id,this.todaysdate).subscribe(res => {
  //     console.log("res",res);
  //     this.reportData = res;
  //     this.topBlockReport = res.topBlock;
  //     this.lineChartDataNew = res.vaccinationDoneByTime;
  //     this.lastSevenDaysReg = res.last7DaysRegistration;
  //     this.getBeneficiariesGroupBy = res.getBeneficiariesGroupBy;
  //     this.last7DaysVaccination = res.last7DaysVaccination;
  //     this.lastSevenDaysAppointment = res.last7DaysRegistration;
  //     this.prepareDataForSemiPieChartsNew();
  //     this.prepareDataForLineGraphNew();
  //     this.prepareDataForStackedBarRegGraphNew();
  //     this.prepareDataForLastSevenDaysVacc();

  //     if(this.state_id =='' && this.district_id == ''){
  //       this.tableheader = " Vaccination By State/UT"
  //     }else if(this.state_id !='' && this.district_id == ''){
  //       this.tableheader = " Vaccination By District";
  //     }else if(this.state_id !='' && this.district_id != ''){
  //       this.tableheader = " Vaccination By Center";
  //     }
  //   });
  // }

  // prepareDataForLastSevenDaysVacc() {
  //   const format = this.numberFormatPipe;
  //   if ( this.lastSevenDayVaccChart) {
  //     this.lastSevenDayVaccChart.destroy();
  //   }
  //   const labels = this.last7DaysVaccination.map(obj => moment(obj.vaccine_date).format('DD MMM'));
  //   const doseOne = this.last7DaysVaccination.map(obj => obj.dose_one);
  //   const doseTwo = this.last7DaysVaccination.map(obj => obj.dose_two);
  //   var vaccConfig = {
  //     type: 'bar',
  //     data: {
  //         labels: labels,
  //         datasets: [{
  //             type: 'bar',
  //             label: 'Dose 1',
  //             backgroundColor: "rgb(85 86 253)",
  //             borderColor: "rgb(85 86 253)",
  //             data: doseOne,
  //         }, {
  //             type: 'bar',
  //             label: 'Dose 2',
  //             backgroundColor: "rgb(75 222 219)",
  //             borderColor: "rgb(75 222 219)",
  //             data: doseTwo,
  //         }]
  //     },
  //     options: {
  //         legend: {
  //             display: true,
  //             position: 'bottom',
  //             labels: {
  //                 usePointStyle: false,
  //                 fontSize: 10,
  //                 boxWidth: 10,
  //                 padding: 15,
  //             }
  //         },
  //         tooltips: {
  //           mode: 'index',
  //           intersect: false,
  //           callbacks: {
  //             label: function(tooltipItem, data) {
  //                 var label = data.datasets[tooltipItem.datasetIndex].label || '';

  //                 if (label) {
  //                     label += ': ';
  //                 }
  //                 const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
  //                 label += format.transform(dataNum);
  //                 return label;
  //             }
  //         }
  //       },
  //         scales: {
  //             xAxes: [{
  //                 barPercentage: 0.25,
  //                 beginAtZero: true,
  //                 ticks: {
  //                     autoSkip: false,
  //                     fontSize: 10,
  //                 },
  //                 stacked: true,
  //                 gridLines: {
  //                     display: false,
  //                     drawBorder: false,
  //                 },
  //             }],
  //             yAxes: [{
  //                 stacked: true,
  //                 barPercentage: 0.35,
  //                 gridLines: {
  //                     color: 'rgb(247, 250, 252)',
  //                     borderDash: [5, 0],
  //                     zeroLineColor: 'rgb(247, 250, 252)',
  //                 },
  //                 ticks: {
  //                     fontSize: 11,
  //                 }
  //             }]
  //         },
  //     }
  // };

  //   var ctx = $('#vaccine-last-30');
  //   this.lastSevenDayVaccChart = new Chart(ctx, vaccConfig);
  // }

  // prepareDataForSemiPieChartsNew() {
  //   const format = this.numberFormatPipe;
  //   var configcmr2 = {
  //     type: 'pie',
  //     data: {
  //         datasets: [{
  //             data: [
  //                 this.topBlockReport?.vaccination?.male,
  //                 this.topBlockReport?.vaccination?.female,
  //                 this.topBlockReport?.vaccination?.others
  //             ],
  //             backgroundColor: ['rgb(90, 141, 238)', 'rgb(245, 67, 148)', 'rgb(255 152 0)'],
  //             borderWidth: 1,
  //         }],
  //         labels: ['Male', 'Female', 'Other']
  //     },
  //     options: {
  //         cutoutPercentage: 70,
  //         rotation: 1 * Math.PI,
  //         circumference: 1 * Math.PI,
  //         responsive: true,
  //         animation: {
  //             animateScale: true,
  //             animateRotate: true
  //         },
  //         tooltips: {
  //           mode: 'index',
  //           intersect: false,
  //           callbacks: {
  //             label: function(tooltipItem, data) {
  //                 var label = data.labels[tooltipItem.index] || '';

  //                 if (label) {
  //                     label += ': ';
  //                 }
  //                 const value = data.datasets[0].data[tooltipItem.index] || 0
  //                 const dataNum = Math.round(value * 100) / 100;
  //                 label += format.transform(dataNum);
  //                 return label;
  //             }
  //         }
  //       },
  //         legend: {
  //             display: true,
  //             position: 'bottom',
  //             labels: {
  //                 usePointStyle: true,
  //                 boxWidth: 7,
  //                 padding: 15,
  //                 fontSize: 10,
  //             }
  //         }
  //     }
  //   };

  //   var configcmr22 = {
  //     type: 'pie',
  //     data: {
  //         datasets: [{
  //             data: [
  //               this.topBlockReport?.vaccination?.covishield,
  //               this.topBlockReport?.vaccination?.covaxin
  //             ],
  //             backgroundColor: ['rgb(104 177 241)', 'rgb(81 202 158)'],
  //             borderWidth: 1,
  //         }],
  //         labels: ['Covishield', 'Covaxin']
  //     },
  //     options: {
  //       cutoutPercentage: 70,
  //       rotation: 1 * Math.PI,
  //       circumference: 1 * Math.PI,
  //       responsive: true,
  //       animation: {
  //           animateScale: true,
  //           animateRotate: true
  //       },
  //       tooltips: {
  //         mode: 'index',
  //         intersect: false,
  //         callbacks: {
  //           label: function(tooltipItem, data) {
  //               var label = data.labels[tooltipItem.index] || '';

  //               if (label) {
  //                   label += ': ';
  //               }
  //               const value = data.datasets[0].data[tooltipItem.index] || 0
  //               const dataNum = Math.round(value * 100) / 100;
  //               label += format.transform(dataNum);
  //               return label;
  //           }
  //       }
  //     },
  //       legend: {
  //           display: true,
  //           position: 'bottom',
  //           labels: {
  //               usePointStyle: true,
  //               boxWidth: 7,
  //               padding: 15,
  //               fontSize: 10,
  //           }
  //       }
  //     }
  //   };

  //   if (this.genderVaccPieChart) {
  //     this.genderVaccPieChart.destroy()
  //   }

  //   if (this.materialVaccPieChart) {
  //     this.materialVaccPieChart.destroy()
  //   }

  //   const genderCtx = $('#total-vaccinated-gender');
  //   this.genderVaccPieChart = new Chart(genderCtx, configcmr2);

  //   const materialCtx = $('#material-used');
  //   this.materialVaccPieChart = new Chart(materialCtx, configcmr22);
  // }

  // prepareDataForStackedBarRegGraphNew() {
  //   if ( this.lastSevenDayChart) {
  //     this.lastSevenDayChart.destroy();
  //   }
  //   const ctx = $('#lastSevenReg');
  //   const labels = this.lastSevenDaysReg.map(obj => {
  //     return moment(obj.reg_date).format('DD MMM')
  //   });
  //   const maleData = this.lastSevenDaysReg.map(obj => {
  //     return obj.male;
  //   });

  //   const femaleData = this.lastSevenDaysReg.map(obj => {
  //     return obj.female;
  //   });

  //   const othersData = this.lastSevenDaysReg.map(obj => {
  //     return obj.others;
  //   });
  //   const format = this.numberFormatPipe;
  //   var lastSevenDayRegChartObj = {
  //     type: 'bar',
  //     data: {
  //         labels: labels,
  //         datasets: [{
  //             type: 'bar',
  //             label: 'Male',
  //             backgroundColor: "rgb(85 86 253)",
  //             borderColor: "rgb(85 86 253)",
  //             data: maleData,
  //         }, {
  //             type: 'bar',
  //             label: 'Female',
  //             backgroundColor: "rgba(255,105,165)",
  //             borderColor: "rgba(255,105,165)",
  //             data: femaleData,
  //         },
  //         {
  //           type: 'bar',
  //           label: 'Others',
  //           backgroundColor: "rgb(72, 219, 179)",
  //           borderColor: "rgb(72, 219, 179)",
  //           data: othersData,
  //       }]
  //     },
  //     options: {
  //       tooltips: {
  //         mode: 'index',
  //         intersect: false,
  //         callbacks: {
  //           label: function(tooltipItem, data) {
  //               var label = data.datasets[tooltipItem.datasetIndex].label || '';

  //               if (label) {
  //                   label += ': ';
  //               }
  //               const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
  //               label += format.transform(dataNum);
  //               return label;
  //           }
  //       }
  //     },
  //         legend: {
  //             display: true,
  //             position: 'bottom',
  //             labels: {
  //                 usePointStyle: false,
  //                 fontSize: 10,
  //                 boxWidth: 10,
  //                 padding: 15,
  //             }
  //         },
  //         scales: {
  //             xAxes: [{
  //                 barPercentage: 0.25,
  //                 beginAtZero: true,
  //                 ticks: {
  //                     autoSkip: false,
  //                     fontSize: 10
  //                 },
  //                 stacked: true,
  //                 gridLines: {
  //                     display: false,
  //                     drawBorder: false,
  //                 },
  //             }],
  //             yAxes: [{
  //                 stacked: true,
  //                 barPercentage: 0.35,
  //                 gridLines: {
  //                     color: 'rgb(247, 250, 252)',
  //                     borderDash: [5, 0],
  //                     zeroLineColor: 'rgb(247, 250, 252)',
  //                 },
  //                 ticks: {
  //                     fontSize: 11,
  //                 }
  //             }]
  //         },
  //       }
  //   };

  //   this.lastSevenDayChart = new Chart(ctx,lastSevenDayRegChartObj);

  //   // lastSevenReg
  // }

  //last seven days appointments
  // prepareDataForStackedBarAppointmentGraphNew() {
  //   if ( this.lastSevenDayAppointmentChart) {
  //     this.lastSevenDayAppointmentChart.destroy();
  //   }
  //   const ctx = $('#lastSevenAppointment');
  //   const labels = this.lastSevenDaysAppointment.map(obj => {
  //     return moment(obj.reg_date).format('DD MMM')
  //   });
  //   const maleData = this.lastSevenDaysAppointment.map(obj => {
  //     return obj.male;
  //   });

  //   const femaleData = this.lastSevenDaysAppointment.map(obj => {
  //     return obj.female;
  //   });

  //   const othersData = this.lastSevenDaysAppointment.map(obj => {
  //     return obj.others;
  //   });
  //   const format = this.numberFormatPipe;
  //   var lastSevenDayAppointmentChartObj = {
  //     type: 'bar',
  //     data: {
  //         labels: labels,
  //         datasets: [{
  //             type: 'bar',
  //             label: 'Male',
  //             backgroundColor: "rgb(85 86 253)",
  //             borderColor: "rgb(85 86 253)",
  //             data: maleData,
  //         }, {
  //             type: 'bar',
  //             label: 'Female',
  //             backgroundColor: "rgba(255,105,165)",
  //             borderColor: "rgba(255,105,165)",
  //             data: femaleData,
  //         },
  //         {
  //           type: 'bar',
  //           label: 'Others',
  //           backgroundColor: "rgb(72, 219, 179)",
  //           borderColor: "rgb(72, 219, 179)",
  //           data: othersData,
  //       }]
  //     },
  //     options: {
  //       tooltips: {
  //         mode: 'index',
  //         intersect: false,
  //         callbacks: {
  //           label: function(tooltipItem, data) {
  //               var label = data.datasets[tooltipItem.datasetIndex].label || '';

  //               if (label) {
  //                   label += ': ';
  //               }
  //               const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
  //               label += format.transform(dataNum);
  //               return label;
  //           }
  //       }
  //     },
  //         legend: {
  //             display: true,
  //             position: 'bottom',
  //             labels: {
  //                 usePointStyle: false,
  //                 fontSize: 10,
  //                 boxWidth: 10,
  //                 padding: 15,
  //             }
  //         },
  //         scales: {
  //             xAxes: [{
  //                 barPercentage: 0.25,
  //                 beginAtZero: true,
  //                 ticks: {
  //                     autoSkip: false,
  //                     fontSize: 10
  //                 },
  //                 stacked: true,
  //                 gridLines: {
  //                     display: false,
  //                     drawBorder: false,
  //                 },
  //             }],
  //             yAxes: [{
  //                 stacked: true,
  //                 barPercentage: 0.35,
  //                 gridLines: {
  //                     color: 'rgb(247, 250, 252)',
  //                     borderDash: [5, 0],
  //                     zeroLineColor: 'rgb(247, 250, 252)',
  //                 },
  //                 ticks: {
  //                     fontSize: 11,
  //                 }
  //             }]
  //         },
  //       }
  //   };

  //   this.lastSevenDayAppointmentChart = new Chart(ctx,lastSevenDayAppointmentChartObj);

  //   // lastSevenAppointment
  // }


  // prepareDataForLineGraphNew() {
  //   if ( this.realTimeChart) {
  //     this.realTimeChart.destroy();
  //   }


  //   const ctx = $('#realtime');

  //   this.lineChartData = this.lineChartDataNew.sort((a, b) => (a.timestamps > b.timestamps) ? 1 : -1)
  //   console.log("this.lineChartData1", this.lineChartDataNew)

  //   /* const labels = _.map(this.lineChartData,(data) => {
  //     return data.label;
  //   }); */
  //   const labels = _.map(this.lineChartDataNew,(data) => {
  //     return moment(data.timestamps).subtract(330,"minutes").format('HH:mm');
  //   });
  //   console.log("lable",labels )
  //   const data1 = _.map(this.lineChartDataNew,'count');
  //   const data2 = _.map(this.lineChartDataNew,'dose_one');
  //   const data3 = _.map(this.lineChartDataNew,'dose_two');
  //   const format = this.numberFormatPipe;
  //   var vaccConfig = {
  //     type: 'line',
  //     data: {
  //         labels: labels,
  //         datasets: [{
  //             type: 'line',
  //             label: 'Total',
  //             // backgroundColor: 'rgb(255, 152 , 0, 0.5)',
  //             // backgroundColor: "rgb(255, 152 , 0, 0.8)",
  //             borderColor: "rgb(255, 152 , 0, 0.8)",
  //             borderWidth: 1,
  //             pointBackgroundColor: "rgb(255, 152 , 0)",
  //             pointBorderColor: 'rgb(255, 255, 255)',
  //             pointBorderWidth: 1,
  //             pointRadius: 3,
  //             fill: true,
  //             data: data1,
  //         } ,{
  //             type: 'line',
  //             label: 'Dose 2',
  //             backgroundColor: 'rgb(41, 184, 155, 0.5)',
  //             borderColor: "rgb(41, 184, 155)",
  //             borderWidth: 1,
  //             pointBackgroundColor: 'rgb(41, 184, 155)',
  //             pointBorderColor: 'rgb(255, 255, 255)',
  //             pointBorderWidth: 1,
  //             pointRadius: 3,
  //             fill: true,
  //             data: data3,
  //         },
  //         {
  //           type: 'line',
  //           label: 'Dose 1',
  //           backgroundColor: "rgb(73 105 233 / 20%)",
  //           borderColor: "rgb(73 105 233)",
  //           borderWidth: 1,
  //           pointBackgroundColor: 'rgb(73 105 233)',
  //           pointBorderColor: 'rgb(255, 255, 255)',
  //           pointBorderWidth: 1,
  //           pointRadius: 3,
  //           fill: true,
  //           data: data2,
  //       }]
  //     },
  //     options: {
  //         legend: {
  //             display: true,
  //             position: 'bottom',
  //             labels: {
  //                 usePointStyle: false,
  //                 boxWidth: 20,
  //                 padding: 15,
  //                 fontSize: 9,
  //             }
  //         },
  //         tooltips: {
  //             mode: 'index',
  //             intersect: false,
  //             callbacks: {
  //               label: function(tooltipItem, data) {
  //                   var label = data.datasets[tooltipItem.datasetIndex].label || '';

  //                   if (label) {
  //                       label += ': ';
  //                   }
  //                   const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
  //                   label += format.transform(dataNum);
  //                   return label;
  //               }
  //           }
  //         },
  //         responsive: true,
  //         scales: {
  //             xAxes: [{
  //                 beginAtZero: false,
  //                 ticks: {
  //                     autoSkip: false,
  //                     fontSize: 11,
  //                 },
  //                 // stacked: true,
  //                 gridLines: {
  //                     display: false,
  //                     drawBorder: false,
  //                 },
  //             }],
  //             yAxes: [{
  //                 // stacked: true,
  //                 barPercentage: 0.3,
  //                 gridLines: {
  //                     color: 'rgb(247, 250, 252)',
  //                     borderDash: [5, 2],
  //                     zeroLineColor: 'rgb(247, 250, 252)',
  //                 },
  //                 ticks: {
  //                     fontSize: 11,
  //                     beginAtZero: true,
  //                 }
  //             }]
  //         }
  //     }
  //   };

  //   this.realTimeChart = new Chart(ctx, vaccConfig);
  //   this.realTimeChart.update();
  // }



  //new code from vinod - 11/02/2021

  loadReportByTab(textLabel) {
    console.log('textLabel', textLabel);
    this.publicReportService.tabname.next(textLabel);
    if (textLabel === 'Dashboard') {
      this.publicReportService.tabname.next('Dashboard');
      // this.publicReportService.getTabname().subscribe(val => {

      //   if (val && val != undefined) {
      //     console.log("checkingddd", val);

      //       console.log("test", val);
      //       this.stateArr = this.states.find(e => e.state_id ==  this.state_id);
      //     this.heading = this.stateArr.state_name;
      //     this.site_logo = this.stateArr.state_code;


      //   }
      // })
      // this.mainDashboard.getNewDashboardData();
      // this.mainDashboard.getNewDashboardData();
      this.newmainDashboard.getDashboardData();

      this.newmainDashboard.getVacChartData('Today');
      // this.mainDashboard.getVaccChartAgewiseDataMonth('Last 30 Days');

      // this.mainDashboard.getRegChartDataMonth('Last 30 Days');
      // this.mainDashboard.getUptrendVacChartDataMonth('Last 30 Days');
      // this.mainDashboard.getVacChartData('Today');


    } else if (textLabel === 'Registration') {

      this.regDashboardRprt.getRegistrationDashboard(this.todaysdate);

    } else if (textLabel === 'Vaccination') {
      // this.vaccDashboardRprt.getVaccinationDashboard(this.todaysdate);
      this.vaccDashboardRprt.nextLevel(this.type);
    }
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e:any) {
    if (window.pageYOffset > 100) {
      let element:any = document.getElementById('navbar');
      element.classList.add('sticky');
    } else {
     let element:any = document.getElementById('navbar');
       element.classList.remove('sticky');
    }
  }

}


